import { filterSaga } from 'components/DrawerFilter/filterSaga'
import { adminSaga } from 'features/Admin/adminSaga'
import { all } from 'redux-saga/effects'

export default function* rootSaga() {
    yield all([adminSaga(), filterSaga()])
}